import { BrowserAgent, Logging, Metrics } from '@newrelic/browser-agent';

const NEWRELIC_CONFIG = {
  licenseKey: import.meta.env.VITE_NEW_RELIC_LICENSE_KEY,
  accountID: import.meta.env.VITE_NEW_RELIC_ACCOUNT_ID, // oc-app3-prod or oc-app3-nonprod
  applicationID: import.meta.env.VITE_NEW_RELIC_APP_ID, // Income Calculator (env)
  trustKey: import.meta.env.VITE_NEW_RELIC_TRUST_KEY,
};

export const initializeNewRelic = () => {
  const { licenseKey, accountID, applicationID, trustKey } = NEWRELIC_CONFIG;

  const agentID = applicationID;
  const beacon = 'gov-bam.nr-data.net';
  const errorBeacon = beacon;

  const config = {
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: true },
    },
    info: {
      beacon,
      errorBeacon,
      licenseKey,
      applicationID,
      sa: 1,
    },
    loader_config: {
      accountID,
      trustKey,
      agentID,
      licenseKey,
      applicationID,
    },
    features: [Logging, Metrics],
  };

  new BrowserAgent(config);
  const newrelic = globalThis.newrelic;

  const releaseVersion = `${import.meta.env.VITE_GIT_HASH}`;

  if (releaseVersion) {
    newrelic.addRelease('ic', releaseVersion);
  }
  newrelic.setCustomAttribute('team_name', 'oc-apply');
  newrelic.setCustomAttribute('Application', 'income-calculator');
  newrelic.setCustomAttribute('FISMA', 'mpl');
};
